import React from 'react'
import { hydrate, render } from 'react-dom'
import './index.css'
import App from './containers/App'
import 'tachyons'

import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import ErrorBoundary from './ErrorBoundary'

import { store } from './redux/store'

import { GoogleOAuthProvider } from '@react-oauth/google'
import * as serviceWorker from './serviceWorker'

// Guard against "Failed to execute 'removeChild'/'insertBefore'" crashes caused by
// browser auto-translators (e.g. Quark, Google Translate) mutating React-managed text
// nodes. When the node React wants to remove/insert against is no longer where it
// expects, we no-op instead of letting the DOM throw. See facebook/react#11538.
if (typeof Node === 'function' && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild
  Node.prototype.removeChild = function (child) {
    if (child.parentNode !== this) {
      if (process.env.NODE_ENV !== 'production') {
        console.warn('Cannot remove a child from a different parent', child, this)
      }
      return child
    }
    return originalRemoveChild.apply(this, arguments)
  }

  const originalInsertBefore = Node.prototype.insertBefore
  Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      if (process.env.NODE_ENV !== 'production') {
        console.warn('Cannot insert before a reference node from a different parent', referenceNode, this)
      }
      return newNode
    }
    return originalInsertBefore.apply(this, arguments)
  }
}

const rootElement = document.getElementById('root')

if (module.hot && process.env.NODE_ENV !== 'production') {
  module.hot.accept()
}

if (rootElement.hasChildNodes()) {
  hydrate(
    <Provider store={store}>
      <GoogleOAuthProvider clientId={`${process.env.REACT_APP_GOOGLE_API_KEY}`}>
        <BrowserRouter>
          <ErrorBoundary>
            <App />
          </ErrorBoundary>
        </BrowserRouter>
      </GoogleOAuthProvider>
    </Provider>,
    rootElement,
  )
} else {
  render(
    <Provider store={store}>
      <GoogleOAuthProvider clientId={`${process.env.REACT_APP_GOOGLE_API_KEY}`}>
        <BrowserRouter>
          <ErrorBoundary>
            <App />
          </ErrorBoundary>
        </BrowserRouter>
      </GoogleOAuthProvider>
    </Provider>,
    rootElement,
  )
}

serviceWorker.unregister()
